















































































































































































































import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator';
import { OrganisationState, Organisation } from '@/types';
import { Action, Getter, Mutation } from 'vuex-class';
import UserProfileForm from '@/components/UserProfileForm.vue';
import { RouterHelper } from '@/router';

@Component({
  components: {
    UserProfileForm,
  },
})
export default class Navigation extends Vue {
  private showMenu: boolean = false;
  private showComposeMenu: boolean = false;
  private showManageMenu: boolean = false;
  private showPublishMenu: boolean = false;
  private showSubscriptionsMenu: boolean = false;
  private showCogMenu: boolean = false;
  private showAccountMenu: boolean = false;
  private modalVisible: boolean = false;
  private selectedOrganisation!: any;
  private mobileMenuHidden: boolean = true;
  @Action private userLogout: any;
  @Action private userDetailsAsync: any;
  @Getter private organisations: any;
  @Getter private login: any;
  // TODO: Organisation scoping
  @Getter private activeOrganisationId: any;
  @Getter private activeOrganisation: any;

  private async onSelectedOrganisationChanged(id: string) {
    this.menuShown(false);
    await RouterHelper.switchOrganisation(Number(id));
  }

  private activateMenu() {
    this.showMenu = true;
  }

  private menuShown(value: boolean) {
    this.showMenu = value;
  }

  private activateComposeMenu() {
    this.showComposeMenu = true;
  }

  private activateManageMenu() {
    this.showManageMenu = true;
  }

  private activatePublishMenu() {
    this.showPublishMenu = true;
  }

  private activateSubscriptionsMenu() {
    this.showSubscriptionsMenu = true;
  }

  private composeMenuShown(value: boolean) {
    this.showComposeMenu = value;
  }

  private manageMenuShown(value: boolean) {
    this.showManageMenu = value;
  }

  private publishMenuShown(value: boolean) {
    this.showPublishMenu = value;
  }

  private subscriptionsMenuShown(value: boolean) {
    this.showSubscriptionsMenu = value;
  }

  private activateCogMenu() {
    this.showCogMenu = true;
  }

  private cogMenuShown(value: boolean) {
    this.showCogMenu = value;
  }

  private activateAccountMenu() {
    this.showAccountMenu = true;
  }

  private accountMenuShown(value: boolean) {
    this.showAccountMenu = value;
  }

  private toggleMobileMenu() {
    this.mobileMenuHidden = !this.mobileMenuHidden;
  }

  private logout() {
    this.userLogout();
  }

  private userDetails(field: string) {
    if (!this.login || !this.login.details) {
      return '-';
    }
    if (field === 'name') {
      return `${this.login.details.first_name} ${this.login.details.last_name}`;
    }
    if (field === 'email') {
      return `${this.login.details.email}`;
    }
  }

  private async showModal() {
    await this.userDetailsAsync();
    this.modalVisible = true;
    // this.menuShown(false);
  }

  private async closeModal() {
    await this.userDetailsAsync();
    this.modalVisible = false;
  }
}
